export { default as StartEarningRewardsComponent } from "./StartEarningRewardsComponent";
export type { IReward } from "./StartEarningRewardsComponent";
